import { FC } from 'react'
import { FilterSection } from '@/network/graphql.g'
import useTranslation from 'next-translate/useTranslation'
import MobileFilterGridItem, {
  MobileFilterItemType
} from './mobileFilterGridItem'

type Props = {
  categories: FilterSection[]
  initialSelections: string[]
  updatePendingFilter: (ids: string[]) => void
}

const FilterCategoriesSlidePage: FC<Props> = ({
  categories,
  initialSelections,
  updatePendingFilter
}) => {
  const { t } = useTranslation('common')
  const items: MobileFilterItemType[] = categories.flatMap((s) =>
    s.items.map((i) => ({
      id: i.id,
      title: i.value,
      count: i.count
    }))
  )

  return (
    <MobileFilterGridItem
      items={items}
      selectedIds={initialSelections}
      onSelectionChange={updatePendingFilter}
      withSearch={true}
      searchPlaceholder={t('Category.Filter.categoriesSearchPlaceholder')}
    />
  )
}
export default FilterCategoriesSlidePage
